import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import ReactTooltip from "react-tooltip";
import { useTracking } from "react-tracking";
import { useTranslation } from "react-i18next";
import { catalogSectionClean, cleanSearchingCatalogSectionsPaginated } from "../../app/actions/catalogSectionActions";
import DisplayNameAndRole from "./DisplayNameAndRole";

const NavbarIconsCatalogSections = ({ page }) => {
  const dispatch = useDispatch();
  const { trackEvent } = useTracking();
  const { t } = useTranslation();

    const { isUserAuthenticated } = useSelector((state) => state.auth);

  const [activeIcon, setActiveIcon] = useState(null);

  const handleActiveIcon = (icon) => {
    
    if (icon === "new") {
      
      trackEvent({ component: "NewCatalogSections", event: "NewCatalogSections-Clicked" });
    } else if (icon === "list") {
      
      trackEvent({ component: "ListCatalogSections", event: "ListCatalogSections-Clicked" });
      dispatch(cleanSearchingCatalogSectionsPaginated());
    }

    dispatch(catalogSectionClean());
    setActiveIcon(icon);
  };

  const iconActiveStyle = (icon) => {
    if (activeIcon === icon) {
      return "icon-d-flex active";
    } else {
      return "icon-d-flex";
    }
  };

  return (
    <div className="d-flex justify-content-between align-items-center flex-nowrap gradient-custom-sky custom-nav-height">
      {isUserAuthenticated && (
        <DisplayNameAndRole />
      )}
      {page === "listCatalogSections" && (
        <Link
          data-tip
          data-for="newCatalogSectionsTip"
          to="/admin-section/new-section"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("new")}
        >
          <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "newCatalogSections" && (
        <Link
          data-tip
          data-for="listCatalogSectionsTip"
          to="/admin-section/"
          className="p-2 bd-highlight"
          onClick={() => handleActiveIcon("list")}
        >
          <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
        </Link>
      )}
      {page === "editCatalogSections" && (
        <div className="navbar-module-actions">
          <Link
            data-tip
            data-for="listCatalogSectionsTip"
            to="/admin-section/"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("list")}
          >
            <i className={`fa fa-table fa-2x ${iconActiveStyle("list")}`} aria-hidden="true" />
          </Link>
          <Link
            data-tip
            data-for="newCatalogSectionsTip"
            to="/admin-section/new-section"
            className="p-2 bd-highlight"
            onClick={() => handleActiveIcon("new")}
          >
            <i className={`fa fa-plus-square fa-2x ${iconActiveStyle("new")}`} aria-hidden="true" />
          </Link>
        </div>
      )}

      <ReactTooltip id="newCatalogSectionsTip" place="left" effect="solid">
        {t("admin-section.page.register")}
      </ReactTooltip>
      <ReactTooltip id="listCatalogSectionsTip" place="left" effect="solid">
        {t("admin-section.page.list")}
      </ReactTooltip>
    </div>
  );
};

export default NavbarIconsCatalogSections;
